import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {SearchSubscriptions$Json$Params} from "../../../swagger-gen/web-secured/fn/subscriptions/search-subscriptions-json";
import {SubscriptionList} from "../../../swagger-gen/web-secured/models/subscription-list";

export const SubscriptionsActions = createActionGroup({
  source: "Subscriptions",
  events: {
    Search: props<{filter: SearchSubscriptions$Json$Params}>(),
    "loader Start": emptyProps(),
    "Fetch Success": props<{ response: SubscriptionList}>(),
    "Fetch Failure": props<{ message: string }>(),
    Clean: emptyProps(),
  },
});

